import { render, staticRenderFns } from "./show-stock.html?vue&type=template&id=fda63b18&scoped=true&external"
import script from "./show-stock.js?vue&type=script&lang=js&external"
export * from "./show-stock.js?vue&type=script&lang=js&external"
import style0 from "./show-stock.scss?vue&type=style&index=0&id=fda63b18&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda63b18",
  null
  
)

export default component.exports